import { mergeMap, tap } from 'rxjs/operators';
import { delay, distinctUntilChanged, skip, filter, take, map } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import { selectBqRecordsInStore, selectBqRecordsPageLoading, selectBqRecordsShowInitWaitingMessage } from '../_selectors/BqRecords.selectors';


export class BqRecordsDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
        super();

		this.loading$ = this.store.pipe(
			select(selectBqRecordsPageLoading),
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectBqRecordsShowInitWaitingMessage)
        );
        
        this.store.pipe(
			select(selectBqRecordsInStore),
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});

    }
}